/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useSetRecoilState } from "recoil";

import BasicTabScreenType from "../screenTypes/functional/BasicTabScreenType";
import EguPopProductManage from "./EguPopProductManage";
import apiClient from "../../lib/common/apiClient";
import notificationState from "../../states/notificationState";
import Notification from "../presentation/Notification";

function PopProductManageProcess(props) {
    const [tab, setTab] = useState();
    const [processCategoryCode, setProcessCategoryCode] = useState([]);
    const [processCategoryName, setProcessCategoryName] = useState([]);
    const [processCategory, setProcessCategory] = useState({});
    const [loadFailed, setLoadFailed] = useState(false);
    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            if(mounted) {
                let result;
                try {
                    result = await apiClient.get("/api/mainProcessView/process");
                } catch (reason) {
                    // 알림 부품은 탭 안 목록 화면에만 있어 탭을 만들지 않으면 화면이 직접 그려야 보인다
                    if (mounted) {
                        setLoadFailed(true);
                    }
                    setNotification({
                        severity: "error",
                        msg: reason.response ? reason.response.data : reason.message,
                        open: true,
                    });
                    return;
                }
                let sortNumber = [];
                result.data.data.push({
                    no: 998,
                    processCategoryCode: "PopEtc",
                    processCategoryName: "기타"
                },
                {
                    no: 999,
                    processCategoryCode: "PopAll",
                    processCategoryName: "전체"
                });
                for(const item of result.data.data) {
                    sortNumber.push(String(item.no).padStart(3, "0"));
                }

                sortNumber.sort();

                let code = [];
                let name = [];
                for(const number of sortNumber) {
                    for(const item of result.data.data) {
                        if(number === String(item.no).padStart(3, "0")) {
                            code.push(item.processCategoryCode);
                            name.push(item.processCategoryName);
                        }
                    }
                }

                // 중복 데이터 제거
                let processCategoryCode = code.filter((item, index) => code.indexOf(item) === index);
                let processCategoryName = name.filter((item, index) => name.indexOf(item) === index);

                setProcessCategoryCode(processCategoryCode);
                setProcessCategoryName(processCategoryName);
                setProcessCategory(result.data.data);

                setTab(code[0]);
            }
        })();

        return () => {
            mounted = false;
        }
    }, []);

    const onTabChanged = (tab) => {
        setTab(tab);
    };

    return (
        <>
        {loadFailed && <Notification />}
        <BasicTabScreenType
            id="popProductManageProcess"
            tabs={processCategoryCode}
            tabLabels={processCategoryName}
            tabsStyle={{
                left: 0,
                margin: "0px",
                padding:"0px",
                height: "48px",
                width: "1200px"
            }}
            onTabChanged={onTabChanged}
            value={tab}
        >
            <EguPopProductManageTab viewName={tab} processCategory={processCategory} />
        </BasicTabScreenType>
        </>
    );
}

function EguPopProductManageTab(props) {
    const { viewName, processCategory } = props;

    let id;
    let name;
    for(const item in processCategory) {
        if(processCategory[item].processCategoryCode === viewName) {
            id = processCategory[item].processCategoryCode;
            name = processCategory[item].processCategoryName;
        }
    }

    if(id === undefined) {
        return <></>
    }

    return <EguPopProductManage id={id} name={name} />;
}

export default PopProductManageProcess;
